import Vue from 'vue'
import VueRouter from 'vue-router'
import login from '../views/login.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/', // 根路径重定向到index
    redirect: '/index'
  },
  {
    path: '/login',
    name: 'login',
    component: login
  },
  {
    path: '/index',
    name: 'index',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/index.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach(async (to, from, next) => {
  if (to.path == '/login') {
    next();
  } else {
    if (localStorage.getItem('zhimingUserTokenData')) {
      //删除$store.state.planData  因为要删除课件按钮课件
      // if (to.path == '/homework' || to.path == '/homework') {//原逻辑被删掉了。这里没有必要清除课件列表了
      //   const store = Vue.prototype.$store;
      //   store.commit('getCoursewareList', null);
      //   store.commit('getCoursewarevideoList', null);
      //   localStorage.removeItem('notify')
      //   localStorage.setItem('courseButton', true)
      //   localStorage.removeItem('NOteach')
      //   sessionStorage.clear()
      // }
      // if (to.path == '/courseware') {
      //   console.log(to.path);
      //   localStorage.setItem('courseButton', false)
      // }
      next();
    } else {
      next('/login');
    }
  }
});
export default router
